import Typography from 'components/Typography';
import React from 'react';
import { Cancel } from '@material-ui/icons';

import { Container } from './styles';

const IndicateToItem = ({ name, onClick }) => {
  return (
    <Container>
      <Typography variant="manrope">{name}</Typography>
      <Cancel size={20} onClick={() => onClick()} />
    </Container>
  );
};

export default IndicateToItem;